import type { FaireProductEntity } from "../../entity_types/product";

export const p_estee38kn7: FaireProductEntity = {
  token: "p_estee38kn7",
  type: "product",
  name: "Oatmeal Creme Sandwich - Single Serve",
  brandToken: "b_1q83xmlpct",
  brandName: "Maxine's Heavenly",
  imageUrl:
    "https://cdn.faire.com/fastly/1e0a05cff77f8f41544ba864ee1ae9b1a8fd3d387ad330b284bc4fbd68839786.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/56caebc9d2edcbe462c10bb8d3eb0522969ff259e865d73c89aa856792e9c8fa.jpeg",
    "https://cdn.faire.com/fastly/3272000ea1f7c9bcd7e80fe9c8a64e1b7b5f18ece4d47d3be437dae2d5ad10a9.png",
    "https://cdn.faire.com/fastly/3a18164e1e280466f37cf7859f9ed93e2f04632888ac6f4f42ca0c558312f107.png",
    "https://cdn.faire.com/fastly/e421558ce30e637d454aaa170e1b04c3d7e07d9d709627a2b9c008eec14a8cbe.jpeg",
    "https://cdn.faire.com/fastly/61379071c56b7bb4d8db155d5697eac9d1a5e4237d0aca7ff198c6a011516d13.png",
    "https://cdn.faire.com/fastly/e7ac79c693bb5d1a34a2c17700cf5a27bd8777c635555d9286b0572d0615096f.jpeg",
  ],
  priceDollars: 2.41,
  description:
    "Our take on this childhood classic may actually be better than the original. Two oatmeal cookies brought together with cream filling—but this time there's no high fructose corn sugar involved!  \n\nA sleeve of 10 eaches (retail ready, single serve Oatmeal Creme Sandwiches). Sold here by the master case of 6 inner sleeves (60 units).",
  tags: [],
  msrpDollars: 4.14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:43.014Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
